module.exports = __webpack_public_path__ + "img/SOKAL-Final-Color.0287dade.png";